module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-form', {
    model: {
      value: (_vm.isAddValid),
      callback: function($$v) {
        _vm.isAddValid = $$v
      },
      expression: "isAddValid"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('center', {
    staticStyle: {
      "width": "100%"
    }
  }, [(_vm.departmentLoader == true) ? _c('img', {
    staticClass: "imgLoader",
    attrs: {
      "src": require("../../shared/assets/images/3dloader.gif")
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.departmentLoader == false) ? _c('v-tabs', {
    attrs: {
      "slider-color": "grey"
    }
  }, [_c('v-tab', {
    key: 1,
    staticClass: "tab",
    attrs: {
      "ripple": ""
    }
  }, [_vm._v("Deparment Details")]), _vm._v(" "), _c('v-tab', {
    key: 2,
    staticClass: "tab",
    attrs: {
      "ripple": ""
    }
  }, [_vm._v("Department Calculator")]), _vm._v(" "), _c('v-tab', {
    key: 3,
    staticClass: "tab",
    attrs: {
      "ripple": ""
    }
  }, [_vm._v("Department Product Codes")]), _vm._v(" "), _c('v-tab', {
    key: 4,
    staticClass: "tab",
    attrs: {
      "ripple": ""
    }
  }, [_vm._v("Department Status Rules")]), _vm._v(" "), _c('v-tab', {
    key: 5,
    staticClass: "tab",
    attrs: {
      "ripple": ""
    }
  }, [_vm._v("Department Quote Edit Screen")]), _vm._v(" "), _c('v-tab-item', {
    key: 1,
    staticClass: "pl-4 pr-4 pt-4 pb-4"
  }, [_c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Department Name:")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Name",
      "required": "",
      "rules": _vm.nameRules,
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.departmentName),
      callback: function($$v) {
        _vm.departmentName = $$v
      },
      expression: "departmentName"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Department Description:")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Description",
      "required": "",
      "rules": _vm.descriptionRules,
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.departmentDescription),
      callback: function($$v) {
        _vm.departmentDescription = $$v
      },
      expression: "departmentDescription"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Department Terms & Conditions Link:")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Terms & Conditions Link",
      "required": "",
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.departmentTerms),
      callback: function($$v) {
        _vm.departmentTerms = $$v
      },
      expression: "departmentTerms"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Department Sales Margin:")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Department Margin",
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.departmentMargin),
      callback: function($$v) {
        _vm.departmentMargin = $$v
      },
      expression: "departmentMargin"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Department Installation Margin:")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Department Margin",
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.departmentInstallationMargin),
      callback: function($$v) {
        _vm.departmentInstallationMargin = $$v
      },
      expression: "departmentInstallationMargin"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    key: 2,
    staticClass: "pl-4 pr-4 pt-4 pb-4"
  }, [_c('v-container', {
    staticStyle: {
      "padding-top": "10px !important"
    },
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Department Ranges:")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.departmentRangesList,
      "item-value": "id32",
      "rules": _vm.branchRules,
      "item-text": "name",
      "label": "Department Ranges",
      "autocomplete": "",
      "solo": "",
      "multiple": ""
    },
    model: {
      value: (_vm.departmentRanges),
      callback: function($$v) {
        _vm.departmentRanges = $$v
      },
      expression: "departmentRanges"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    key: 3,
    staticClass: "pl-4 pr-4 pt-4 pb-4"
  }, [_c('v-container', {
    staticStyle: {
      "padding-top": "10px !important"
    },
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('input', {
    attrs: {
      "type": "file",
      "id": "articleImport"
    },
    on: {
      "change": _vm.fncSetImageObj
    }
  })]), _vm._v(" "), _vm._l((_vm.product_codes), function(product_code, index) {
    return _c('v-flex', {
      attrs: {
        "lg3": ""
      }
    }, [_c('v-text-field', {
      attrs: {
        "label": "Product Code",
        "single-line": "",
        "solo": ""
      },
      model: {
        value: (_vm.product_codes[index].value),
        callback: function($$v) {
          _vm.$set(_vm.product_codes[index], "value", $$v)
        },
        expression: "product_codes[index].value"
      }
    }), _vm._v(" "), _c('a', {
      staticClass: "departmentRangeRemove",
      on: {
        "click": function($event) {
          return _vm.fncRemoveDepartmentRange(index)
        }
      }
    }, [_vm._v("Remove")])], 1)
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "color": "success"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncAddProductCode()
      }
    }
  }, [_vm._v("Add Product Code\n                ")])], 1)], 2)], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    key: 4,
    staticClass: "pl-4 pr-4 pt-4 pb-4"
  }, [_c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "info"
    },
    on: {
      "click": _vm.fncAddStatusRules
    }
  }, [_vm._v("Add Rule")])], 1), _vm._v(" "), (_vm.statusRules.length > 0) ? _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "loading": "true",
      "headers": _vm.headers,
      "items": _vm.statusRules,
      "hide-actions": "",
      "disable-initial-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          staticClass: "sortableRow",
          attrs: {
            "id": "rows"
          }
        }, [_c('td', {
          attrs: {
            "width": "15%"
          }
        }, [_c('v-select', {
          staticClass: "dropdown",
          staticStyle: {
            "margin-top": "4px !important"
          },
          attrs: {
            "items": _vm.serviceType,
            "placeholder": "Service Type",
            "item-value": "id",
            "item-text": "name",
            "outline": "",
            "autocomplete": ""
          },
          model: {
            value: (props.item.type),
            callback: function($$v) {
              _vm.$set(props.item, "type", $$v)
            },
            expression: "props.item.type"
          }
        })], 1), _vm._v(" "), _c('td', {
          attrs: {
            "width": "20%"
          }
        }, [_c('v-select', {
          staticClass: "dropdown",
          staticStyle: {
            "margin-top": "4px !important"
          },
          attrs: {
            "items": _vm.userRoles,
            "placeholder": "Roles",
            "item-value": "id",
            "item-text": "name",
            "multiple": "",
            "outline": "",
            "autocomplete": ""
          },
          model: {
            value: (props.item.originator),
            callback: function($$v) {
              _vm.$set(props.item, "originator", $$v)
            },
            expression: "props.item.originator"
          }
        })], 1), _vm._v(" "), _c('td', {
          attrs: {
            "width": "25%"
          }
        }, [_c('v-select', {
          staticClass: "dropdown",
          staticStyle: {
            "margin-top": "4px !important"
          },
          attrs: {
            "items": _vm.userRoles,
            "placeholder": "Roles",
            "item-value": "id",
            "item-text": "name",
            "multiple": "",
            "outline": "",
            "autocomplete": ""
          },
          model: {
            value: (props.item.roles),
            callback: function($$v) {
              _vm.$set(props.item, "roles", $$v)
            },
            expression: "props.item.roles"
          }
        })], 1), _vm._v(" "), _c('td', {
          attrs: {
            "width": "15%"
          }
        }, [_c('v-select', {
          staticClass: "dropdown",
          staticStyle: {
            "margin-top": "4px !important"
          },
          attrs: {
            "items": _vm.designationType,
            "placeholder": "Designation",
            "item-value": "id",
            "item-text": "name",
            "multiple": "",
            "outline": "",
            "autocomplete": ""
          },
          model: {
            value: (props.item.designation),
            callback: function($$v) {
              _vm.$set(props.item, "designation", $$v)
            },
            expression: "props.item.designation"
          }
        })], 1), _vm._v(" "), _c('td', {
          attrs: {
            "width": "15%"
          }
        }, [_c('v-select', {
          staticClass: "dropdown",
          staticStyle: {
            "margin-top": "4px !important"
          },
          attrs: {
            "items": _vm.statusList,
            "placeholder": "Status",
            "item-value": "id",
            "item-text": "description",
            "outline": "",
            "autocomplete": ""
          },
          model: {
            value: (props.item.status),
            callback: function($$v) {
              _vm.$set(props.item, "status", $$v)
            },
            expression: "props.item.status"
          }
        })], 1), _vm._v(" "), _c('td', {
          attrs: {
            "width": "10%"
          }
        }, [_c('a', {
          on: {
            "click": function($event) {
              return _vm.fncDeleteStatusRule(props.item)
            }
          }
        }, [_vm._v("Delete")])])])]
      }
    }], null, false, 3531334264)
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    key: 5,
    staticClass: "pl-4 pr-4 pt-4 pb-4"
  }, [_c('v-container', {
    staticStyle: {
      "padding-top": "10px !important"
    },
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Can Add More Rows")]), _vm._v(" "), _c('v-switch', {
    attrs: {
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.canAddRows),
      callback: function($$v) {
        _vm.canAddRows = $$v
      },
      expression: "canAddRows"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Has Linked Line Items")]), _vm._v(" "), _c('v-switch', {
    attrs: {
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.linkedItems),
      callback: function($$v) {
        _vm.linkedItems = $$v
      },
      expression: "linkedItems"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Calculator")]), _vm._v(" "), _c('v-switch', {
    attrs: {
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.calculator),
      callback: function($$v) {
        _vm.calculator = $$v
      },
      expression: "calculator"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Location")]), _vm._v(" "), _c('v-switch', {
    attrs: {
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.location),
      callback: function($$v) {
        _vm.location = $$v
      },
      expression: "location"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Article Description")]), _vm._v(" "), _c('v-switch', {
    attrs: {
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.articleDescription),
      callback: function($$v) {
        _vm.articleDescription = $$v
      },
      expression: "articleDescription"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("BW Article No.")]), _vm._v(" "), _c('v-switch', {
    attrs: {
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.bwArticleNo),
      callback: function($$v) {
        _vm.bwArticleNo = $$v
      },
      expression: "bwArticleNo"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Vendor")]), _vm._v(" "), _c('v-switch', {
    attrs: {
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.vendor),
      callback: function($$v) {
        _vm.vendor = $$v
      },
      expression: "vendor"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Plant Code")]), _vm._v(" "), _c('v-switch', {
    attrs: {
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.plantCode),
      callback: function($$v) {
        _vm.plantCode = $$v
      },
      expression: "plantCode"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Product Description")]), _vm._v(" "), _c('v-switch', {
    attrs: {
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.productDescription),
      callback: function($$v) {
        _vm.productDescription = $$v
      },
      expression: "productDescription"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Quantity")]), _vm._v(" "), _c('v-switch', {
    attrs: {
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.quantity),
      callback: function($$v) {
        _vm.quantity = $$v
      },
      expression: "quantity"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("UOM")]), _vm._v(" "), _c('v-switch', {
    attrs: {
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.uom),
      callback: function($$v) {
        _vm.uom = $$v
      },
      expression: "uom"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Hire Date")]), _vm._v(" "), _c('v-switch', {
    attrs: {
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.hireDate),
      callback: function($$v) {
        _vm.hireDate = $$v
      },
      expression: "hireDate"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Hire Period")]), _vm._v(" "), _c('v-switch', {
    attrs: {
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.hirePeriod),
      callback: function($$v) {
        _vm.hirePeriod = $$v
      },
      expression: "hirePeriod"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Delivery Method")]), _vm._v(" "), _c('v-switch', {
    attrs: {
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.deliveryMethod),
      callback: function($$v) {
        _vm.deliveryMethod = $$v
      },
      expression: "deliveryMethod"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Receival Time")]), _vm._v(" "), _c('v-switch', {
    attrs: {
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.receivalTime),
      callback: function($$v) {
        _vm.receivalTime = $$v
      },
      expression: "receivalTime"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Unit Selling Price ( ex VAT )")]), _vm._v(" "), _c('v-switch', {
    attrs: {
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.unitSellingPriceExVat),
      callback: function($$v) {
        _vm.unitSellingPriceExVat = $$v
      },
      expression: "unitSellingPriceExVat"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Unit Vat")]), _vm._v(" "), _c('v-switch', {
    attrs: {
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.unitVat),
      callback: function($$v) {
        _vm.unitVat = $$v
      },
      expression: "unitVat"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Unit Total ( inc VAT )")]), _vm._v(" "), _c('v-switch', {
    attrs: {
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.unitTotalIncVat),
      callback: function($$v) {
        _vm.unitTotalIncVat = $$v
      },
      expression: "unitTotalIncVat"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Total (inc VAT)")]), _vm._v(" "), _c('v-switch', {
    attrs: {
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.totalIncVat),
      callback: function($$v) {
        _vm.totalIncVat = $$v
      },
      expression: "totalIncVat"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Vendor Unit Cost (ex VAT)")]), _vm._v(" "), _c('v-switch', {
    attrs: {
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.vendorUnitCostExVat),
      callback: function($$v) {
        _vm.vendorUnitCostExVat = $$v
      },
      expression: "vendorUnitCostExVat"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Margin")]), _vm._v(" "), _c('v-switch', {
    attrs: {
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.margin),
      callback: function($$v) {
        _vm.margin = $$v
      },
      expression: "margin"
    }
  })], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pl-4 pr-1 pb-4 buttonHolder"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    staticClass: "text-xs-right cancelButton",
    attrs: {
      "color": "success"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncHideModal.apply(null, arguments)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.runAdd) ? _c('v-progress-circular', {
    staticClass: "pt-3 loginLoader",
    attrs: {
      "indeterminate": "",
      "width": 3,
      "size": 20,
      "color": "grey"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.addressSelected == false) ? _c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "color": "success",
      "disabled": true
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncAddDepartment()
      }
    }
  }, [_vm._v("Save\n          ")]) : _c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "color": "success"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncAddDepartment()
      }
    }
  }, [_vm._v("Save\n          ")]), _vm._v(" "), _c('small', [_vm._v("* The button will activate once all required fields have been completed")])], 1)])], 1)], 1)], 1)
},staticRenderFns: []}